module.exports = __webpack_public_path__ + "img/swiper5.1ff26cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/swiper5.png
// module id = 422
// module chunks = 0